<template>
<div class="box">
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">
				<h2>Facebook</h2>
			</div>
		</div>
		<div class="box__body">
			<div class="facebook" :aria-busy="facebookLoading ? 'true' : 'false'">
				<div class="facebook__avatar" v-if="user.fb_page_id">
					<img :src="user.facebook_active_page.picture.data.url" alt="">
				</div>
				<div class="facebook__information">
					<div>
						<h2 v-if="user.fb_page_id">{{ 'active-page' | translate | uppercase }}</h2>
						<h2 v-else>{{ 'desactive-page' | translate | uppercase }}</h2>

						<p v-if="user.fb_page_id">{{ user.facebook_active_page.name }}</p>
						<p v-else>{{ 'no-acess' | translate }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="box__footer">
			<ul class="box__footer__buttons" v-if="user.fb_page_id">
				<li>
					<button href="#" @click="facebookProcess">
						{{ 'changeChatBot' | translate }}
					</button>
				</li>
				<li>
					<button href="#" @click="disconnectFacebook" v-if="user.fb_page_id">
						{{ 'disconnectChatBot' | translate }}
					</button>
				</li>
			</ul>
			<div class="facebook-button" v-else>
				<div
				class="fb-login-button"
				data-max-rows="1"
				data-size="medium"
				data-button-type="continue_with"
				data-show-faces="false"
				data-auto-logout-link="false"
				data-use-continue-as="false"
				onlogin="facebookProcess()"
				></div>
			</div>
		</div>
			<div v-show="facebookPageList">
			<form @submit.prevent="confirmPageAccess" v-if="(this.pagesSession) ? this.pagesSession.data : ''">
				<div class="facebook-lists">
				<div class="form__group" v-for="page in pagesSession.data" :key="page.id">
					<ul class="form__options">
						<li><label>
							<input type="radio" name="page" :value="page.id" v-model="formFacebook.pageChoiceId">
							{{ page.name }}</label>
						</li>
					</ul>
				</div>
				</div>
				<div class="form__group">
					<div class="clearfix text-center margin-top" :aria-busy="submitLoading ? 'true' : 'false'">
						<div class="submit__content">
							<button type="submit">{{ 'save' | translate }}</button>
						</div>
					</div>
				</div>
				<div class="has-error" v-show="Object.keys(errors).length">
				<span class="control-label" v-for="(error, index ) in errors" :key="index"><i class="fas fa-times-circle-o"></i> {{ error | translate }}
				</span>
				</div>
			</form>
			</div>
			<div class="form__group has-success text-center margin-top">
				<label class="control-label" for="inputSuccess" v-show="successMessage">
					<i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}
				</label>
			</div>
	</div>
</div>
</template>

<script>
// eslint-disable-next-line
import config from 'config';
import axios from 'axios';

export default {
	name: 'facebook',
	components: {
		config,
	},
	data() {
		return {
			alert: false,
			slowClass: '',
			edit: false,
			facebookPageList: true,
			pagesSession: {},
			submitLoading: false,
			facebookLoading: false,
			formFacebook: {
				pageChoiceId: (this.user) ? this.user.fb_page_id : '',
			},
			successMessage: false,
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		errors() {
			return this.$store.state.error;
		},
		success() {
			return this.$store.state.status;
		},
	},
	beforeCreate() {
		window.fbAsyncInit = () => {
			// eslint-disable-next-line
			FB.init({
				appId: config.appId,
				autoLogAppEvents: true,
				xfbml: true,
				version: 'v3.1',
			});
		};
		(((d, s, id) => {
			const fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			const js = d.createElement(s);
			js.id = id;
			js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
			fjs.parentNode.insertBefore(js, fjs);
		})(document, 'script', 'facebook-jssdk'));

		const session = {
			apiKey: sessionStorage.getItem('apiKey'),
			userId: sessionStorage.getItem('userId'),
		};
		this.$store.dispatch('loadUser', session).then(() => {
			this.$store.dispatch('getOffice', this.user.gender);
		});
	},
	mounted() {
		/* eslint-disable */
		window.facebookProcess = this.facebookProcess;
		FB.XFBML.parse();
	},
		methods: {
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		toggleFacebookLoading() {
			this.facebookLoading = !this.facebookLoading;
		},
		errorForm(obj, field) {
			let error = '';
			if (obj[field]) {
			error = true;
			}
			return error;
		},
		disconnectFacebook() {
			FB.getLoginStatus((response) => {
			const accessToken = this.user.fb_page_access_token;
			const pageId = this.user.fb_page_id;

			const obj = {
				session: {
				userId: sessionStorage.getItem('userId'),
				apiKey: sessionStorage.getItem('apiKey'),
				},
				str: {
				deactivate_chatbot: 1,
				},
			};
			this.successMessage = false;

			this.toggleFacebookLoading();

			this.$store.dispatch('editOfficer', obj)
				.then(() => {
				axios.delete(`https://graph.facebook.com/v3.1/${pageId}/subscribed_apps?access_token=${accessToken}`)
				.then((response) => {
					this.$store.dispatch('loadUser', obj.session)
					.then(() => {
					this.pagesSession = {};
					this.toggleFacebookLoading();
					setTimeout(() => {
						FB.XFBML.parse();
					}, 500);
					})
					.catch((e) => {
					this.toggleFacebookLoading();
					FB.XFBML.parse();
					});
				})
				.catch((e) => {
					this.toggleFacebookLoading();
					FB.XFBML.parse();
				});
				})
				.catch(() => {
					this.toggleFacebookLoading();
					FB.XFBML.parse();
				});
			});
		},
		facebookProcess() {
			/* eslint-disable */
			this.successMessage = false;
			this.facebookPageList = true;

			FB.getLoginStatus((response) => {
			if (response.status === 'unknown' || response.status === 'not_authorized') {
				FB.login(() => {
				FB.api(
					`${FB.getUserID()}/accounts`,
					'get', {
					accessToken: FB.getAccessToken(),
					},
					(pages) => {
					const storagePages = new Promise((resolve) => {
						const pagesStorage = sessionStorage.setItem(
						'pages',
						JSON.stringify(pages),
						);
						resolve(pagesStorage);
					});
					storagePages.then(() => {
						this.pagesSession = JSON.parse(sessionStorage.getItem('pages'));
					});
					},
				);
				}, {
				scope: 'email, manage_pages, pages_messaging, public_profile, pages_messaging_subscriptions',
				return_scopes: true,
				});
			} else if (this.user.fb_page_access_token === null || this.user.fb_page_id) {
				FB.login(() => {
				FB.api(
					`${FB.getUserID()}/accounts`,
					'get', {
					accessToken: FB.getAccessToken(),
					},
					(pages) => {
					const storagePages = new Promise((resolve) => {
						const pagesStorage = sessionStorage.setItem(
						'pages',
						JSON.stringify(pages),
						);
						resolve(pagesStorage);
					});
					storagePages.then(() => {
						this.pagesSession = JSON.parse(sessionStorage.getItem('pages'));
					});
					},
				);
				}, {
				scope: 'email, manage_pages, pages_messaging, public_profile, pages_messaging_subscriptions',
				return_scopes: true,
				});
			} else if (response.status === 'connected') {

				if(response.authResponse.accessToken) {
				var accessToken = response.authResponse.accessToken;
				FB.api(
					`${FB.getUserID()}/accounts`,
					(pages) => {
					const storagePages = new Promise((resolve) => {
						const pagesStorage = sessionStorage.setItem(
						'pages',
						JSON.stringify(pages),
						);
						resolve(pagesStorage);
					});
					storagePages.then(() => {
						this.pagesSession = JSON.parse(sessionStorage.getItem('pages'));
					});
					},
				);

				} else {
				FB.login((response) => {
					FB.api(
					`${FB.getUserID()}/accounts`,
					'get', {
						accessToken: FB.getAccessToken(),
					},
					(pages) => {
						const storagePages = new Promise((resolve) => {
						const pagesStorage = sessionStorage.setItem(
							'pages',
							JSON.stringify(pages),
						);
						resolve(pagesStorage);
						});
						storagePages.then(() => {
						this.pagesSession = JSON.parse(sessionStorage.getItem('pages'));
						});
					},
					);
				}, {
					scope: 'email, manage_pages, pages_messaging, public_profile, pages_messaging_subscriptions',
					return_scopes: true,
				});
				}
			} else {
				FB.login(() => {
				FB.api(
					`${FB.getUserID()}/accounts`,
					'get', {
					accessToken: FB.getAccessToken(),
					},
					(pages) => {
					const storagePages = new Promise((resolve) => {
						const pagesStorage = sessionStorage.setItem(
						'pages',
						JSON.stringify(pages),
						);
						resolve(pagesStorage);
					});
					storagePages.then(() => {
						this.pagesSession = JSON.parse(sessionStorage.getItem('pages'));
					});
					},
				);
				}, {
				scope: 'email, manage_pages, pages_messaging, public_profile, pages_messaging_subscriptions',
				return_scopes: true,
				});
			}
			});
		},
		validate() {
			this.successMessage = true;
			setTimeout(() => {
			this.successMessage = false;
			}, 5000);
		},
		confirmPageAccess() {
			const sessionPages = JSON.parse(sessionStorage.getItem('pages'));
			const pageFilter = sessionPages.data
			.filter(page => page.id === this.$data.formFacebook.pageChoiceId);
			const {
			id: fb_page_id,
			access_token: fb_page_access_token,
			} = pageFilter[0];
			const obj = {
			session: {
				userId: sessionStorage.getItem('userId'),
				apiKey: sessionStorage.getItem('apiKey'),
			},
			str: {
				fb_page_id,
				fb_page_access_token,
			},
			};

			this.toggleFacebookLoading();
			this.toggleSubmitLoading();
			this.facebookPageList = false;
			this.$store.dispatch('editOfficer', obj)
			.then(() => {
				this.$store.dispatch('loadUser', obj.session)
				.then(() => {
					axios.post(`https://graph.facebook.com/v3.1/${fb_page_id}/subscribed_apps?access_token=${
					fb_page_access_token}&subscribed_fields=messages,messaging_optins,messaging_postbacks`)
					.then((response) => {
					if (response.data.success) {
						axios.get(`https://graph.facebook.com/v3.1/${fb_page_id}/subscribed_apps?access_token=${fb_page_access_token}`)
						.then((app) => {
							if (app.data.data.length >= 1) {
							this.$store.dispatch('loadUser', obj.session);
							this.validate(this.formFacebook);
							}
						});
					}
					this.toggleSubmitLoading();
					this.toggleFacebookLoading();
					})
					.catch(() => {
					this.toggleSubmitLoading();
					this.toggleFacebookLoading();
					});
				})
				.catch(() => {
					this.toggleSubmitLoading();
					this.toggleFacebookLoading();
				});
			})
			.catch(() => {
				this.toggleSubmitLoading();
				this.toggleFacebookLoading();
			});
		},
		imgUrl(path) {
			return images(`./${path}`);
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/profile/facebook.vue